<template>
  <PageContentLayoutOnly role="region">
    <div class="level">
      <div class="level-left">
        <b-button
          @click.prevent="createBoardDocumentModal()"
          type="is-primary"
          rounded
          :style="{
            ...(breakpoint === 'desktop'
              ? {}
              : {
                  width: '100%'
                })
          }"
        >
          Add Board Document
        </b-button>
      </div>
    </div>
    <ModernTable
      :region="region"
      :filters="filters"
      :rows="rows"
      :columns="columns"
      :pagination="{
        perPage: 12
      }"
      :loading="loading"
      headerColor="#FFF"
      condensed
    >
    </ModernTable>
    <Modal :toggle.sync="toggle">
      <BoardDocumentsModal :boardDocument="selectedBoardDocument" />
    </Modal>
  </PageContentLayoutOnly>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import PageContentLayoutOnly from '@/containers/PageContentLayoutOnly'
import ModernTable from '@/components/tables/Modern/Table'
import BoardDocumentsModal from './component/BoardDocumentModal'
import Modal from '@/components/Modal'
import { windowStore } from '@/utilities/window/store'
import { methods } from '../boardDocuments/keys/methods'
import { data } from '../boardDocuments/keys/data'

export default {
  name: 'BoardDocumentCenter',
  components: {
    PageContentLayoutOnly,
    ModernTable,
    BoardDocumentsModal,
    Modal
  },

  data,

  methods,

  computed: {
    ...mapState({
      hoaId: state => state.user.selectedHoaId,
      ...mapGetters('user', ['authUser', 'retrieveUser'])
    })
  },

  watch: {
    toggle() {
      if (this.toggle == false) {
        this.reload()
        this.toggle = false
        if (this.Modal && this.Modal != undefined) {
          this.Modal.$emit('update:toggle', (this.toggle = false))
        }
      }
    }
  },

  mounted() {
    this.reload()

    this.unsubWindowStore = windowStore.subscribe((mutation, state) => {
      const mType = mutation.type

      if (mType === 'breakPointChange') {
        this.breakpoint = state.breakpoint
      }
    })

    this.breakpoint = windowStore.state.breakpoint
  },

  i18n: {
    messages: {
      en: { documentCenter: { title: 'Board Documents' } }
    }
  }
}
</script>

<style></style>
